'use strict';

module.exports = /*@ngInject*/
function() {
    var model = {
        cookieDomain: '',
        cookieName: '',
        cookieValue: ''
    };

    return {
        init: function(cookieName, cookieValue, toReset, expiryTime) {
            model.cookieDomain = '';
            model.cookieName = 'ANTHRO_' + cookieName;
            model.cookieValue = cookieValue;

            if (
                this.get(model.cookieName) !== cookieValue ||
                /true/.test(cookieValue) ||
                toReset
            ) {
                return this.create(model.cookieName, model.cookieValue, 45, '');
            }

            return null;
        },

        cookie: function(loggedIn, loyaltyCustomer) {
            if (loggedIn) {
                return this.init(
                    'uservalues',
                    'anthro:' + loyaltyCustomer,
                    true
                );
            } else {
                return this.init(
                    'uservalues',
                    'anthro:false'
                );
            }
        },

        create: function(name, value, days, cookieDomain) {
            var expires = '';
            var date;

            if (days) {
                date = new Date();
                date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
                expires = '; expires=' + date.toGMTString();
            }

            document.cookie = name + '=' + value + expires + cookieDomain + '; path=/';

            return document.cookie;
        },

        'delete': function(name) {
            document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
        },

        get: function(lookupCookieName) {
            var results = document.cookie.match('(^|;) ?' + lookupCookieName + '=([^;]*)(;|$)');
            return results ? window.unescape(results[2]) : null;
        }
    };
};
